import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getCurrencySymbol, formatPrice as formatPriceUtil } from '../utils/currency';

const SalonContext = createContext();

export const useSalon = () => {
  const context = useContext(SalonContext);
  if (!context) {
    throw new Error('useSalon must be used within a SalonProvider');
  }
  return context;
};

export const SalonProvider = ({ children, salonId }) => {
  const [salonSettings, setSalonSettings] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchSalonSettings = useCallback(async () => {
    if (!salonId) {
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`/api/salons/${salonId}/settings`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setSalonSettings(response.data.settings || {});
    } catch (error) {
      console.error('Error fetching salon settings:', error);
      setSalonSettings({});
    } finally {
      setLoading(false);
    }
  }, [salonId]);

  useEffect(() => {
    fetchSalonSettings();
  }, [fetchSalonSettings]);

  const currency = salonSettings?.currency?.value || 'EUR';
  const currencySymbol = getCurrencySymbol(currency);

  const formatPrice = useCallback((amount, showSymbol = true) => {
    // Display whole numbers only (e.g. 450 instead of 450.00)
    return formatPriceUtil(amount, currency, showSymbol, 0);
  }, [currency]);

  const value = {
    salonSettings,
    currency,
    currencySymbol,
    formatPrice,
    refreshSettings: fetchSalonSettings,
    loading
  };

  return (
    <SalonContext.Provider value={value}>
      {children}
    </SalonContext.Provider>
  );
};

export default SalonContext;

